import { Hidden, Tile, Collapse, Visible } from 'ia-react-core';
import React, { FC, ReactNode } from 'react';

export interface CollapseTileProps {
  title: string;
  children?: ReactNode;
}

const CollapseTile: FC<CollapseTileProps> = ({ title, children }) => (
  <>
    <Hidden lg xl xxl><Collapse name="search" large white boxShadow borderRadius={4} title={title}>{children}</Collapse></Hidden>
    <Visible lg xl xxl><Tile title={title}>{children}</Tile></Visible>
  </>
);

export default CollapseTile;
